import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["roof-insurance-claims"];

export const Route = createFileRoute("/services/roof-insurance-claims")({
  head: () => ({
    meta: [
      { title: "Roof Insurance Claim Help Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Roof insurance claim help in Southern California: documentation, adjuster coordination and full repair or replacement by a licensed local crew." },
      { property: "og:title", content: "Roof Insurance Claim Help – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/roof-insurance-claims" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});